export default __webpack_public_path__ + "static/media/treeMinus.828b087d.svg";